import {
  CHANGE_PASSWORD_OK,
  CHANGE_PASSWORD_ERR,
} from "./change-password.action";

const InitState = {
  error: null,
  content: null,
};

export default function ChangePasswordReducer(state = InitState, action) {
  switch (action.type) {
    case CHANGE_PASSWORD_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case CHANGE_PASSWORD_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
